import { useEffect } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { GETDANTE_URL } from "constants/navs";

const Logout: React.FC = () => {
  const { logout } = useAuth0();

  useEffect(() => {
    logout({
      logoutParams: {
        returnTo: GETDANTE_URL,
      },
    });
  }, [logout]);

  return null;
};

export default Logout;
